import styled from 'styled-components';

interface IContainerType {
  color?: string;
  error?: boolean;
}

export const Container = styled.div<IContainerType>`
  width: 100%;
  flex: 1;
  cursor: pointer;
  margin-bottom: 0.9rem;

  .custom-select__menu {
    z-index: 15;
  }

  .custom-select__indicators {
    background: transparent;
    svg {
      color: ${({ theme }) => theme.colors.title};
    }
  }
  .custom-select__indicator-separator {
    display: none !important;
  }

  .custom-select__control {
    width: 100%;
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid
      ${({ error, theme }) => (error ? theme.colors.danger.color : theme.colors.border)};
    box-sizing: border-box;
    font-size: 1rem;
    padding: 0.55rem 0.4rem;
    border-radius: 8px;
    box-shadow: 1px 4px 0px 0px rgba(118, 136, 149, 0.2) inset;
  }

  .custom-select__control,
  .custom-select__option {
    cursor: pointer;
  }

  .custom-select__control--is-focused {
    box-shadow: none;
    border-color: hsl(0, 0%, 80%);
  }

  .custom-select__single-value,
  .custom-select__value-container,
  .custom-select__option {
    background: ${({ theme }) => theme.colors.white};
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.texts};
    text-align: left;
  }

  .custom-select__option--is-selected {
    color: ${({ theme }) => theme.colors.primary.contrast} !important;
    background-color: ${({ theme }) => theme.colors.primary.color} !important;
  }

  .custom-select__option:active {
    background: ${({ theme }) => theme.colors.light.color} !important;
    color: ${({ theme }) => theme.colors.texts} !important;
  }

  .custom-select__option:hover:not(.custom-select__option--is-selected) {
    background: ${({ theme }) => theme.colors.light.color} !important;
    color: ${({ theme }) => theme.colors.texts} !important;
  }

  .error {
    margin-top: 0;
  }

  .custom-select__multi-value {
    background: ${({ theme }) => theme.colors.primary.color};

    div {
      color: ${({ theme }) => theme.colors.primary.contrast};
      font-size: 1rem;
      line-height: 1.2;
    }

    div[role='button'] {
      &:hover {
        background-color: ${({ theme }) => theme.colors.primary.color};
      }
    }
  }
`;
